// extracted by mini-css-extract-plugin
export default {"processingStepContainer":"ProcessingStep_processingStepContainer__JskTQ","detailedStatusOverride":"ProcessingStep_detailedStatusOverride__pXCIe"};